module.exports = __webpack_public_path__ + "img/login-img.aa05cfde.png";